export enum ADCMClienteTipo {
    Prospecto = 1,
    Cliente = 2
}

export enum ADCMTransaccionTipo {
    DCM = 1,
    ECM = 2,
    ABS = 3
}

export enum ADCMEmisorTipo {
    Corporate = 1,
    Gobierno = 2
}